import React from "react";

const HomePage = () => {
  console.log("Home");
  return <div>HomePage</div>;
};

export default HomePage;
